import React from 'react';
import PropTypes from 'prop-types';

import { Button, Modal, Header, Icon, Form, Message, Dropdown, Grid, TextArea } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';

const ReportClaimModal = ({ open, onReportClaim, onCancel, onFieldChange, data, error, showSuccess, onSuccess }) => {
        let errorMessage;
        if (error) {
            	const content = Array.isArray(error) ? error.map((e, index) => <div key={index}>{`${e}`}</div>) : error;
            	errorMessage = <Message error header='Report Claim Failed' content={content} />;
            }
    
            const { policy, claim } = data;
        const policyOptions = policy.items.map((p) => {
            	return { text: `${p.policyNumber}(${p.type}  ${p.nickname})`, value: p.policyNumber };
            });
        const policyoptionfilter = policyOptions.filter((x) => x.text.substring(0, 3) !== 'WCP');
        return (
            	<Modal size= 'small' open = { open } className = 'claim report' >
                		<Header icon='handshake' size = 'large' content = 'Report Claim' subheader = 'Fill in the fields below to report a claim.' />
                    		{!showSuccess ? (
                        			<Modal.Content>
                        				<Form loading= { claim.loading } error >
                            					<Grid columns='equal' stackable >
                                						<Grid.Row>
                                							<Grid.Column>
                                								<Form.Field>
                                									<label>Policy</label >
                                    									<Dropdown name='policyNumber' placeholder = 'Choose a policy' selection options = { policyoptionfilter } onChange = { onFieldChange } />
                                        								</Form.Field >
                                            								<Form.Field required >
                                            									<label>What's Damaged?</label>
                                             {/* <input name="lossType" placeholder="Loss Type" disabled value={claim.lossType} /> */ }
                                             <Dropdown name='lossType' placeholder='Choose Loss Type' selection options={claim.lossTypeOptions || []} onChange={onFieldChange} />
                                                								</Form.Field >
                                                
                                                    								<Form.Field required >
                                                    									<label>Loss Date</label >
                                                        									<DatePicker name='lossDate' placeholderText = 'Date of Loss' selected = { claim.lossDate } onChange = { onFieldChange } showTimeSelect timeIntervals = { 15} dateFormat = 'PPPp' />
                                                            								</Form.Field >
                                                                							</Grid.Column >
                                                                    							<Grid.Column>
                                                                    								<Form.Field>
                                                                    									<label>Policyholder</label >
                                                                        									<input name='policyHolder' placeholder = 'Full Name' onChange = { onFieldChange } value = { claim.policyHolder } />
                                                                            								</Form.Field >
                                                                                								<Form.Field>
                                                                                									<label>Email address</label >
                                                                                    									<input name='emailAddress' placeholder = 'Email Address' onChange = { onFieldChange } value = { claim.emailAddress } />
                                                                                        								</Form.Field >
                                                                                            								<Form.Field required >
                                                                                            									<label>Phone number</label >
                                                                                                									<input name='phoneNumber' placeholder = 'Phone Number' onChange = { onFieldChange } value = { claim.phoneNumber } />
                                                                                                    								</Form.Field >
                                                                                                        							</Grid.Column >
                                                                                                            						</Grid.Row >
                                                                                                            
                                                                                                                						<Grid.Row>
                                                                                                                							<Grid.Column>
                                                                                                                								<Form.Checkbox name='injuriesExist' label = 'Do injuries exist or was there any medical treatment?' onChange = { onFieldChange } checked = { claim.injuriesExist || false } />
                                                                                                                    								<Form.Field required name = 'lossDescription' control = { TextArea } label = 'Description' placeholder = 'Description' onChange = { onFieldChange } />
                                                                                                                        							</Grid.Column >
                                                                                                                            						</Grid.Row >
                                                                                                                                						<Header as='h5' style = {{ color: 'red', alignContent: 'center' }
} content = 'To report a Workers Compensation claim, please contact your agent.' />
        						{ errorMessage }
        					</Grid>
            				</Form >
                			</Modal.Content >
                    		) : (
                        			<Modal.Content className= 'success' >
                        				<Icon name='check circle' size = 'massive' color = 'green' />
                            				<Header as='h1' content = 'Policy Added Successfully!' />
                                			</Modal.Content >
                                    		)}

    		{!showSuccess ? (
        			<Modal.Actions>
        				<Button content= 'Cancel' onClick = { onCancel } disabled = { claim.loading } />
            				<Button primary content = 'Report Claim' onClick = { onReportClaim } disabled = { claim.loading } />
                			</Modal.Actions >
                    		) : (
                        			<Modal.Actions>
                        				<Button positive content = 'Continue' onClick = { onSuccess } disabled = { claim.loading } />
                            			</Modal.Actions >
                                		)}
	</Modal >
    );
};

ReportClaimModal.propTypes = {
    open: PropTypes.bool.isRequired,
        onCancel: PropTypes.func.isRequired,
            onReportClaim: PropTypes.func.isRequired,
                onFieldChange: PropTypes.func.isRequired,
                    data: PropTypes.object.isRequired,
                        showSuccess: PropTypes.bool,
                            onSuccess: PropTypes.func,
                                error: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
                                };

export default ReportClaimModal;